import {
  SET_AUTH_TOKEN,
  SET_IP_ADDRESS,
  SET_LOGOUT,
  SET_AUTH_REFRESH_TOKEN,
  SET_CURRENT_REQ_OBJ,
} from '../utils/constants'

const initialState = {
  authToken: null,
  ipAddress: null,
  isLogout: false,
  refreshToken: null,
  reqObj: null,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_AUTH_TOKEN:
      return { ...state, authToken: payload }
    case SET_IP_ADDRESS:
      return { ...state, ipAddress: payload }
    case SET_AUTH_REFRESH_TOKEN:
      return { ...state, refreshToken: payload }
    case SET_CURRENT_REQ_OBJ:
      return { ...state, reqObj: payload }
    case SET_LOGOUT:
      return { ...initialState, isLogout: payload }
    default:
      return state
  }
}
